import {
  Blockquote, Card, CardContent, Col, Container, Row, Section,
} from 'atoms'
import { ContactCard } from 'organisms'
import { FC, ReactNode } from 'react'

import Styles from './IhrCoach.module.sass'

const IhrCoach: FC<unknown> = () => (
  <>
    <Section background="coach">
      <Container>
        <Row>
          <Col xs={12} sm={8} offsetSm={4} md={7} offsetMd={5} lg={6}>
            <h1 className="my-5 text-sm-start text-md-center">
              Ihr Coach
            </h1>
            <p className="d-none d-sm-block text-md-center">
              {`Ich unterstütze Frauen dabei, ihr Leben glücklich, selbstbestimmt und in Balance zu führen. Ich bin an Ihrer Seite bei Veränderungsprozessen und in akuten Krisenzeiten.`}
            </p>
          </Col>
        </Row>
      </Container>
    </Section>
    <Section className="d-block d-sm-none text-center">
      <Container>
        <p>
          {`Ich unterstütze Frauen dabei, ihr Leben glücklich, selbstbestimmt und in Balance zu führen. Ich bin an Ihrer Seite bei Veränderungsprozessen und in akuten Krisenzeiten.`}
        </p>
      </Container>
    </Section>
    <Section background="vintage">
      <Container>
        <Card className="mb-4">
          <CardContent className="py-4">
            <h2 className={Styles.contentHeadline}>FrauenCoach Cordelia Schmidt</h2>
            <hr />
            <table className={Styles.contentTable}>
              <tbody>
                <TableRow title="">
                  <ul>
                    <li>Dozentin</li>
                    <li>Systemische Therapeutin</li>
                    <li>Systematischer Coach</li>
                    <li>Heilpraktikerin für Psychotherapie</li>
                    <li>Seniorenassistentin Plöner Modell</li>
                    <li>Diplom - Betriebswirtin (FH)</li>
                    <li>1967 in Berlin geboren</li>
                    <li>Zwei erwachsene Töchter</li>
                  </ul>
                </TableRow>
                <TableRow title="Interessen:">
                  Menschen auf ihrem Lebensweg
                </TableRow>
                <TableRow title="Freizeitaktivitäten:">
                  lesen lesen lesen
                </TableRow>
                <TableRow title="Sport:">
                  Karate / Yoga
                </TableRow>
                <TableRow title="Stärke:">
                  Schokolade essen
                </TableRow>
                <TableRow title="Leidenschaft:">
                  Unsere Katze
                </TableRow>
                <TableRow title="Mein Motto:">
                  <Blockquote caption="&mdash; Henry Ford (1863 - 1947)">
                    {`Ob du denkst du kannst es oder kannst es nicht – du wirst auf jeden Fall recht behalten`}
                  </Blockquote>
                </TableRow>
                <TableRow title="Meine Arbeitsweise:">
                  <ul>
                    <li>lösungsorientiert</li>
                    <li>systemisch</li>
                    <li>ganzheitlich</li>
                  </ul>
                </TableRow>
                <TableRow title="Meine Berufserfahrung:">
                  <ul>
                    <li>
                      Dozentin in der Erwachsenenbildung
                    </li>
                    <li>
                      Coaching, Beratung und Therapie im eigenen Büro
                    </li>
                    <li>
                      {`20 Jahre Privat- und Geschäftskundenberatung und Begleitung in einem DAX-Unternehmen`}
                    </li>
                  </ul>
                </TableRow>
              </tbody>
            </table>
          </CardContent>
        </Card>
        <ContactCard />
      </Container>
    </Section>
  </>
)

const TableRow = ({
  title = '',
  children,
}: { title: string, children?: ReactNode }) => (
  <tr>
    <td className="d-none d-sm-table-cell">
      {title && <Topic text={title}/>}
    </td>
    <td>
      {title && <Topic text={title} inContent />}
      {children}
    </td>
  </tr>
)

const Topic = ({ text = '', inContent = false }) => (
  <span className={`${Styles.topic} ${inContent ? 'd-block d-sm-none' : ''}`}>
    {text}
  </span>
)

export default IhrCoach
